<!-- administration tab HTML -->
<div class="container">
    <div class="row administration">
        <div class="col-md-3 col-lg-2 administration-left">
            <div class="client-dd" *ngIf="true">
                <app-alight-drop-down [group]="customerSearchForm" [controlName]="'clientId'" [required]="false"
                    description="clientName" label="Client" [value]="'clientId'" [list]="
            rootService.liveChatCTS.length < 2 ? customerService.clients : rootService.liveChatCTS
                ">
                </app-alight-drop-down>
            </div>
            <!-- <div class="client-dd" >
         
      
          <app-alight-smart-search-drop-down [group]="rootScope.dashboardForm" [controlName]="'clientNameDash'" [required]="false"
          description="clientName" [disable]="false" label="Select a Client*" [value]="'clientName'"
          [list]="customerService.clients" (change)="rootScope.getDashboardLeftNavData($event)"
          (change)="rootScope.getDashboardMyTodo($event)"
          (change)="appointmentsCardService.getDashboardMyAppointments($event)" (change)="getExpand($event)"
         
          >
        </app-alight-smart-search-drop-down> -->



            <span class="section-divider"></span>
            <div class="administration-left-nav pos-relative">

                <section *ngIf="false" class="error-wrapper">
                    <f-alert variant="error" class="error-without-heading">
                        <p class="full-width">
                            <!-- {{ errorMsg}} -->
                        </p>
                    </f-alert>

                </section>

                <div class="batch-nav">

                    <ul class="batch-links">
                        <li class="active">
                            <button title="link"  (click)="openCurrent()" >
                                <i class="fa-regular fa-bell"></i> Current Batch Alert
                            </button>
                        </li>
                        
                        <li  (click)="openArchived()">
                            <button title="link">
                                <i class="fa-light fa-box-archive"></i> Archived Batch Alert</button>
                        </li>
                        <li>
                            <button title="link" (click)="openDeleted()">
                                <i class="fa-light fa-trash"></i> Deleted Batch Alert</button>
                        </li>
                        <li class="">
                            <button title="link" (click)="openCreate()">
                                <i class="fa-regular fa-plus"></i> Create Batch Alert</button>
                        </li>

                    </ul>
                </div>


            </div>

            <div>
            </div>
        </div>
        <div class="col-md-9 col-lg-10 post-relative administration-right">

            <app-admin-filter class="admin-filter" *ngIf="rootService.openAdminFilterDialog"></app-admin-filter>
                  
            

            <!-- create-batch-alert start here  -->
        <div class="row" *ngIf="createBatchTable" >
            <div class="col-md-12 col-lg-9 create-batch-alert">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 title"> 
                            <h3>Create Batch Alert </h3>
                        </div>
                        <div class="row">
                        <section *ngIf="false" class="error-wrapper">
                            <f-alert variant="error" class="">
                                <p class="full-width">
                                    There was a problem saving the data. Try again.
                                </p>
                            </f-alert>
                            <f-alert variant="success" class="hide">
                                <p class="full-width">
                                    Batch alert was created successfully.
                                </p>
                            </f-alert>
        
                        </section>
                      </div>  

                    </div>
                    <form id="batchAlertForm">
                    <div class="row row-bottom-space1">
                        <div class="col-md-6">
                            <app-alight-drop-down [group]="customerAccForm" value="fieldValue" description="fieldValueDescription"
                            label="Type (Required)"></app-alight-drop-down>                            
                        </div>
                        <div class="col-md-6">
                            <app-alight-drop-down [group]="customerAccForm" value="fieldValue" description="fieldValueDescription"
                            label="Subtype (Required)"></app-alight-drop-down>                            
                        </div>                
                    </div>

                    <div class="row">
                        <div class="col-md-6 flex">
                            <mat-form-field appearance="fill" class="component-box">
                                <mat-label>Start Date (MMM-DD-YYYY)</mat-label>
                                <input matInput [matDatepicker]="picker1" [min]="" [max]=""
                                    formControlName="start"  />
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                        </div>
                        
                        <div class="col-md-6 flex">
                            <mat-form-field appearance="fill" class="component-box">
                                <mat-label>End Date (MMM-DD-YYYY)</mat-label>
                                <input matInput [matDatepicker]="picker2" [min]="" [max]=""
                                    formControlName="end" />
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                        
                    </div>
                
                    <div class="row">                        
                        <div class="col-md-12">
                        <mat-form-field appearance="fill" class="component-box error-border">
                            <mat-label>Title</mat-label>
                            <input matInput formControlName="title" id="title" />
                        </mat-form-field>
                        </div>
                    </div> 
                    <div class="row">
                        <div class="col-md-12">
                            <p><strong>Detail</strong> </p>
                            <mat-form-field appearance="fill" class="component-box">
                               
                                <textarea matInput #detail 
                                     formControlName="detail"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">  
                        <p class="hints">Person file (file should be single column containing Global UDP Person ID, in .TXT format )</p>
                                               
                    </div>    
                    <div class="row">  
                        <div class="col-md-10 col-lg-11 attach-file">                                                      
                        <mat-form-field appearance="fill" class="component-box">
                            <mat-label>Person file</mat-label>
                            <input matInput [value]="fileText" readonly formControlName="personFile" id="person-file" (click)="openFile()" />
                        </mat-form-field>
                        </div>
                        <div class="col-md-2 col-lg-1  attach-file-CTA">
                            <f-button text="Browse" type="file" 
                            variant="progressive" (click)="openFile()">
                                <input type="file" #fileInput class="hide" (change)="handle($event)" />
                              </f-button>
                        </div>
                    </div> 
                    <div class="row">                        
                        <div class="col-md-12">
                        <mat-form-field appearance="fill" class="component-box error-border">
                            <mat-label>Description</mat-label>
                            <input matInput readonly  formControlName="description" id="description" />
                        </mat-form-field>
                        </div>
                    </div> 

                    <div class="button-controls">
                        <f-button text="Create" type="submit"  variant="progressive"></f-button>
                    </div>
                </form>    
                </div>
            </div>  
             
            
        </div> 

        

        <!-- Batch Alert Table starts here -->
            <div class="row hide1"  *ngIf="showBatchTable">
                <f-data-card class="col-md-12 admin-details">
                    <div class="admin-header">
                        <h2 class="heading" *ngIf="currentBatchTable" >Current Batch Alert</h2>
                        <h2 class="heading " *ngIf="deletedBatchTable"> Deleted Batch Alert</h2>
                        <h2 class="heading " *ngIf="archivedBatchTable">Archived Batch Alert</h2>
                        <div class="filter flex" >
                            <button mat-button color="primary" class="btn-filter" title="Filters" (click)="openFilter()">
                                <span>
                                    <i class="fa-light fa-filter"></i>
                                </span>
                                <span>Filters</span>
                            </button>
                            <button mat-button color="primary" title="Clear Filter" class="clear-filter" disabled="true">
                                <span>Clear Filter</span>
                            </button>
                        </div>
                    </div>
                    <section class="error-wrapper hide">
                        <f-alert variant="error">
                            <p>
                                There was problem loading the data. <a href="#" class="btn-alert">Try again.</a>
                            </p>
                        </f-alert>

                    </section>

                    <div class="current-batch-table hide1" *ngIf="currentBatchTable" >
                        <app-alight-table class="current-table" [dataSource]="dataSource" [totalRecords]="totalRecords" [gridColumns]="currentColumns"
                        [tableName]="'currentTable'" [rowPerPage]="10" (rowSelection)="rowSelection($event)"
                        [isShowButtons]="false"></app-alight-table>
                        
                        <div class="footer-controls">
                            <div class="footer-controls-left">
                                <f-button text="Delete alert" type="button" variant="destructive" (click)="deleteAlertModal()">
                                </f-button>
                                <f-button text="View participants" type="button" variant="progressive" (click)="viewParticipantModal()">
                                </f-button>
                            </div>
                        </div>
                    </div>    
                    <div class="delete-batch-table hide1" *ngIf="deletedBatchTable">
                        <app-alight-table class="delete-table" [dataSource]="dataSource1" [totalRecords]="totalRecords" [gridColumns]="deleteColumns"
                        [tableName]="'deleteTable'" [rowPerPage]="10" (rowSelection)="rowSelection($event)"
                        [isShowButtons]="false"></app-alight-table>

                    
                    <div class="footer-controls">
                        <div class="footer-controls-left">
                            <f-button text="View participants" type="button" variant="progressive" (click)="viewParticipantModal()">
                            </f-button>
                        </div>
                    </div>
                    </div>

                    <div class="current-batch-table hide1" *ngIf="archivedBatchTable">
                        <app-alight-table class="current-table" [dataSource]="dataSource" [totalRecords]="totalRecords" [gridColumns]="currentColumns"
                        [tableName]="'currentTable'" [rowPerPage]="10" (rowSelection)="rowSelection($event)"
                        [isShowButtons]="false"></app-alight-table>
                        
                       
                    </div>
                       
                </f-data-card>
            </div>            
        </div>
      </div>
      
</div>




